export const downloadFile = (book) => {
    let url;
    try {
        if (!book?.file || typeof book.file !== 'string') throw new Error();
        url = new URL(book.file, window.location.origin);
        if (!['http:', 'https:'].includes(url.protocol)) throw new Error();
    } catch (_) {
        return { status: 'failed', reason: 'invalid_file' };
    }

    const link = document.createElement('a');
    try {
        link.href = url.href;
        link.download = book.fileName || book.name || 'workbook.pdf';
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        // Native downloads do not expose HTTP completion or a saved-file
        // callback. This confirms initiation only, not successful delivery.
        return { status: 'started' };
    } catch (_) {
        return { status: 'failed', reason: 'browser_error' };
    } finally {
        link.remove();
    }
};
